export default __webpack_public_path__ + "static/simple-column-9056d5cd5f46bb6ceacb9c2ab1ccadbd.png";